export default __webpack_public_path__ + "static/media/supportAgent.c29935f4.svg";